import { provideStates } from '@ngxs/store';

import { FBClientIntakeFormsState } from './state/clientIntakeForms.firebase.state';

export const PROVIDE_FB_CLIENT_INTAKE_FORMS_STATE = [
	provideStates([FBClientIntakeFormsState]),
];
